/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/datatypes';
import '../../connect/v2/common/sort';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_api": {
        "nested": {
          "SearchTeamMembersQuery": {
            "fields": {
              "filter": {
                "type": "squareup.team_api.SearchTeamMembersFilter",
                "id": 1,
                "rule": "optional"
              },
              "sortOrder": {
                "type": "squareup.team_api.SearchTeamMembersSortOrder",
                "id": 2,
                "rule": "optional"
              },
              "sort": {
                "type": "squareup.team_api.SearchTeamMembersSort",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "SearchTeamMembersFilter": {
            "fields": {
              "locationIds": {
                "type": "string",
                "id": 1,
                "rule": "repeated"
              },
              "status": {
                "type": "squareup.team_api.TeamMember.Status",
                "id": 2,
                "rule": "optional"
              },
              "emailAddress": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "isOwner": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              },
              "scope": {
                "type": "squareup.team_api.SearchTeamMembersFilter.TeamMemberScope",
                "id": 5,
                "rule": "optional"
              },
              "name": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "statuses": {
                "type": "squareup.team_api.TeamMember.Status",
                "id": 7,
                "rule": "repeated"
              },
              "invitationStatuses": {
                "type": "squareup.team_api.TeamMember.InvitationStatus",
                "id": 8,
                "rule": "repeated"
              },
              "jobIds": {
                "type": "string",
                "id": 9,
                "rule": "repeated"
              },
              "permissionSetIds": {
                "type": "string",
                "id": 10,
                "rule": "repeated"
              },
              "associatedProducts": {
                "type": "squareup.team_api.SearchTeamMembersFilter.AssociatedProductsFilter",
                "id": 11,
                "rule": "repeated"
              }
            },
            "nested": {
              "TeamMemberScope": {
                "values": {
                  "DO_NOT_USE": 0,
                  "ANY": 1,
                  "CAN_VIEW": 2,
                  "CAN_MANAGE": 3
                }
              },
              "AssociatedProductsFilter": {
                "fields": {
                  "productName": {
                    "type": "squareup.team_api.SearchTeamMembersFilter.AssociatedProductsFilter.AssociatedProductName",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "squareup.team_api.TeamMember.AssociatedProducts.AssociatedProduct.AssociatedProductStatus",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "AssociatedProductName": {
                    "values": {
                      "ASSOCIATED_PRODUCT_NAME_DO_NOT_USE": 0,
                      "PAYROLL": 1,
                      "APPOINTMENTS": 2
                    }
                  }
                }
              }
            }
          },
          "SearchTeamMembersSort": {
            "fields": {
              "sortItems": {
                "type": "squareup.team_api.SearchTeamMembersSort.SortItem",
                "id": 1,
                "rule": "repeated"
              }
            },
            "nested": {
              "SortItem": {
                "fields": {
                  "field": {
                    "type": "squareup.team_api.SearchTeamMembersSort.SortItem.Field",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sortOrder": {
                    "type": "squareup.connect.v2.common.SortOrder",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Field": {
                    "values": {
                      "UNKNOWN": 0,
                      "GIVEN_NAME": 1,
                      "FAMILY_NAME": 2,
                      "STATUS": 3,
                      "CREATED_AT": 4,
                      "INVITATION_STATUS": 5
                    }
                  }
                }
              }
            }
          },
          "SearchTeamMembersSortOrder": {
            "fields": {
              "sortOrder": {
                "type": "squareup.team_api.SearchTeamMembersSortOrder.SortOrder",
                "id": 1,
                "rule": "optional"
              }
            },
            "nested": {
              "SortOrder": {
                "values": {
                  "SORT_ORDER_DO_NOT_USE": 0,
                  "FIRST_NAME_LAST_NAME_ASC": 1,
                  "FIRST_NAME_LAST_NAME_DESC": 2,
                  "ACTIVE_STATUS_ASC": 3,
                  "ACTIVE_STATUS_DESC": 4
                }
              }
            }
          },
          "SearchTeamMembersRequest": {
            "fields": {
              "query": {
                "type": "squareup.team_api.SearchTeamMembersQuery",
                "id": 1,
                "rule": "optional"
              },
              "limit": {
                "type": "int32",
                "id": 2,
                "rule": "optional",
                "options": {
                  "default": 100
                }
              },
              "cursor": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "include": {
                "type": "squareup.team_api.TeamMemberIncludes.Include",
                "id": 4,
                "rule": "repeated"
              },
              "fetchFields": {
                "type": "squareup.team_api.TeamMemberFetchFieldScope.FetchField",
                "id": 5,
                "rule": "repeated"
              }
            }
          },
          "SearchTeamMembersResponse": {
            "fields": {
              "teamMembers": {
                "type": "squareup.team_api.TeamMember",
                "id": 1,
                "rule": "repeated"
              },
              "cursor": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "errors": {
                "type": "squareup.connect.v2.resources.Error",
                "id": 3,
                "rule": "repeated"
              },
              "includedResources": {
                "type": "squareup.team_api.TeamMemberIncludedResources",
                "id": 4,
                "rule": "optional"
              },
              "totalTeamMemberCount": {
                "type": "int32",
                "id": 5,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_api?.nested?.SearchTeamMembersQuery && !$root.nested?.squareup?.nested?.team_api?.nested?.SearchTeamMembersFilter && !$root.nested?.squareup?.nested?.team_api?.nested?.SearchTeamMembersFilter?.nested?.TeamMemberScope && !$root.nested?.squareup?.nested?.team_api?.nested?.SearchTeamMembersFilter?.nested?.AssociatedProductsFilter && !$root.nested?.squareup?.nested?.team_api?.nested?.SearchTeamMembersFilter?.nested?.AssociatedProductsFilter?.nested?.AssociatedProductName && !$root.nested?.squareup?.nested?.team_api?.nested?.SearchTeamMembersSort && !$root.nested?.squareup?.nested?.team_api?.nested?.SearchTeamMembersSort?.nested?.SortItem && !$root.nested?.squareup?.nested?.team_api?.nested?.SearchTeamMembersSort?.nested?.SortItem?.nested?.Field && !$root.nested?.squareup?.nested?.team_api?.nested?.SearchTeamMembersSortOrder && !$root.nested?.squareup?.nested?.team_api?.nested?.SearchTeamMembersSortOrder?.nested?.SortOrder && !$root.nested?.squareup?.nested?.team_api?.nested?.SearchTeamMembersRequest && !$root.nested?.squareup?.nested?.team_api?.nested?.SearchTeamMembersResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents the parameters in a search for `TeamMember` objects.
 * --
 *
 * SOURCE SearchTeamMembersQuery @ squareup/team_api/endpoints/search-team-members.proto at 25:1
 */
export const SearchTeamMembersQuery = $root.lookupType('squareup.team_api.SearchTeamMembersQuery');
fixType(SearchTeamMembersQuery);
Builder.createAndAttachToType(SearchTeamMembersQuery);
/**
 * --
 * @desc Represents a filter used in a search for `TeamMember` objects. `AND` logic is applied
 * between the individual fields, and `OR` logic is applied within list-based fields.
 * For example, setting this filter value:
 * ```
 * filter = (locations_ids = ["A", "B"], status = ACTIVE)
 * ```
 * returns only active team members assigned to either location "A" or "B".
 * --
 *
 * SOURCE SearchTeamMembersFilter @ squareup/team_api/endpoints/search-team-members.proto at 45:1
 */
export const SearchTeamMembersFilter = $root.lookupType('squareup.team_api.SearchTeamMembersFilter');
fixType(SearchTeamMembersFilter);
Builder.createAndAttachToType(SearchTeamMembersFilter);
/**
 * @desc Controls which team members are returned based on the scope of the caller.
 *
 * SOURCE TeamMemberScope @ squareup/team_api/endpoints/search-team-members.proto at 72:3
 */
SearchTeamMembersFilter.TeamMemberScope = $root.lookupEnum('squareup.team_api.SearchTeamMembersFilter.TeamMemberScope').values;
/**
 * @desc Filters by team members with the given associated product status.
 * TODO(TFPLAT-455): Finalize with API working group
 *
 * SOURCE AssociatedProductsFilter @ squareup/team_api/endpoints/search-team-members.proto at 112:3
 */
SearchTeamMembersFilter.AssociatedProductsFilter = $root.lookupType('squareup.team_api.SearchTeamMembersFilter.AssociatedProductsFilter');
fixType(SearchTeamMembersFilter.AssociatedProductsFilter);
Builder.createAndAttachToType(SearchTeamMembersFilter.AssociatedProductsFilter);
/**
 * SOURCE AssociatedProductName @ squareup/team_api/endpoints/search-team-members.proto at 115:5
 */
SearchTeamMembersFilter.AssociatedProductsFilter.AssociatedProductName = $root.lookupEnum('squareup.team_api.SearchTeamMembersFilter.AssociatedProductsFilter.AssociatedProductName').values;
/**
 * SOURCE SearchTeamMembersSort @ squareup/team_api/endpoints/search-team-members.proto at 131:1
 */
export const SearchTeamMembersSort = $root.lookupType('squareup.team_api.SearchTeamMembersSort');
fixType(SearchTeamMembersSort);
Builder.createAndAttachToType(SearchTeamMembersSort);
/**
 * SOURCE SortItem @ squareup/team_api/endpoints/search-team-members.proto at 134:3
 */
SearchTeamMembersSort.SortItem = $root.lookupType('squareup.team_api.SearchTeamMembersSort.SortItem');
fixType(SearchTeamMembersSort.SortItem);
Builder.createAndAttachToType(SearchTeamMembersSort.SortItem);
/**
 * SOURCE Field @ squareup/team_api/endpoints/search-team-members.proto at 137:5
 */
SearchTeamMembersSort.SortItem.Field = $root.lookupEnum('squareup.team_api.SearchTeamMembersSort.SortItem.Field').values;
/**
 * SOURCE SearchTeamMembersSortOrder @ squareup/team_api/endpoints/search-team-members.proto at 156:1
 */
export const SearchTeamMembersSortOrder = $root.lookupType('squareup.team_api.SearchTeamMembersSortOrder');
fixType(SearchTeamMembersSortOrder);
Builder.createAndAttachToType(SearchTeamMembersSortOrder);
/**
 * SOURCE SortOrder @ squareup/team_api/endpoints/search-team-members.proto at 159:3
 */
SearchTeamMembersSortOrder.SortOrder = $root.lookupEnum('squareup.team_api.SearchTeamMembersSortOrder.SortOrder').values;
/**
 * --
 * @desc Represents a search request for a filtered list of `TeamMember` objects.
 * --
 *
 * SOURCE SearchTeamMembersRequest @ squareup/team_api/endpoints/search-team-members.proto at 173:1
 */
export const SearchTeamMembersRequest = $root.lookupType('squareup.team_api.SearchTeamMembersRequest');
fixType(SearchTeamMembersRequest);
Builder.createAndAttachToType(SearchTeamMembersRequest);
/**
 * --
 * @desc Represents a response from a search request containing a filtered list of `TeamMember` objects.
 * --
 *
 * SOURCE SearchTeamMembersResponse @ squareup/team_api/endpoints/search-team-members.proto at 237:1
 */
export const SearchTeamMembersResponse = $root.lookupType('squareup.team_api.SearchTeamMembersResponse');
fixType(SearchTeamMembersResponse);
Builder.createAndAttachToType(SearchTeamMembersResponse);